// Chart layouts, TradingView style. Each is a CSS grid: `areas` names one cell
// per pane, in pane order (a = pane 1, b = pane 2, …).

export const LAYOUT_IDS = ["1", "2-columns", "2-rows", "1+2", "4"] as const
export type LayoutId = (typeof LAYOUT_IDS)[number]

export interface Layout {
  readonly id: LayoutId
  readonly label: string
  readonly panes: number
  readonly areas: string
}

export const LAYOUTS: ReadonlyArray<Layout> = [
  { id: "1", label: "Single chart", panes: 1, areas: `"a"` },
  { id: "2-columns", label: "Two side by side", panes: 2, areas: `"a b"` },
  { id: "2-rows", label: "Two stacked", panes: 2, areas: `"a" "b"` },
  { id: "1+2", label: "One large, two small", panes: 3, areas: `"a b" "a c"` },
  { id: "4", label: "Four charts", panes: 4, areas: `"a b" "c d"` }
]

export const layoutById = (id: LayoutId): Layout => LAYOUTS.find((layout) => layout.id === id) ?? LAYOUTS[0]!

export const PANE_AREAS = ["a", "b", "c", "d"] as const

export const MAX_PANES = PANE_AREAS.length
